/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DocumentTypeFromJSON, DocumentTypeToJSON } from './';
export function DocumentFromJSON(json) {
    return DocumentFromJSONTyped(json, false);
}
export function DocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        config: json['config'],
        description: json['description'],
        type: DocumentTypeFromJSON(json['type']),
        ParentId: json['ParentId'],
        orphan: !exists(json, 'orphan') ? undefined : json['orphan'],
        gridLocked: json['gridLocked'],
    };
}
export function DocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        config: value.config,
        description: value.description,
        type: DocumentTypeToJSON(value.type),
        ParentId: value.ParentId,
        orphan: value.orphan,
        gridLocked: value.gridLocked,
    };
}
